import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import OlgaAmosovaName from "../../images/Banners/olga_amosova_name.png"
import Image from "gatsby-plugin-sanity-image"

const BottomLeftBanner = () => {
  const data = useStaticQuery(graphql`
    {
      sanityAdBanner(id: { eq: "-6025e2e7-5795-581f-97b5-7436c86dbe7b" }) {
        url
        _rawMainImage(resolveReferences: { maxDepth: 10 })
      }
    }
  `)
  return (
    <Banner
      className="relative max-w-screen-xl mx-auto rounded pb-5"
      style={{ height: "42.5rem" }}
    >
      <a
        href={data.sanityAdBanner.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="banner"
      >
        <Image
          // pass asset, hotspot, and crop fields
          {...data.sanityAdBanner._rawMainImage}
          // tell Sanity how large to make the image (does not set any CSS)
          width={1900}
          height={600}
          alt={data.sanityAdBanner._rawMainImage.alt || "Finanzas de bolsillo"}
          // style it how you want it
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
        <figcaption className="text-gray-600 font-roboto font-thin text-xs pl-3">
          {data.sanityAdBanner._rawMainImage.caption}
        </figcaption>
        <div className="absolute bottom-0 left-0 animated fadeInDown p-10">
          <img
            className="w-full md:w-72"
            src={OlgaAmosovaName}
            alt="Ольга Амосова концерт"
          />
          <div>
            <p className="text-gray-900 text-lg font-opensanscond">
              <b>Концерт-спектакль.</b> Ивановская государственная филармония
            </p>
          </div>
        </div>
      </a>
    </Banner>
  )
}

const Banner = styled.div``

export default BottomLeftBanner
